import { addScript } from "../../bundles/helpers/add-script";

(async ($) => {
	if (!window.Swiper) await addScript(PUBLIC_PATH + 'vendor/swiper.vendor.js');
	Array.prototype.forEach.call(document.getElementsByClassName('product'), (elem) => {
        Array.prototype.forEach.call(elem.getElementsByClassName('product__slider'), (slider) => {
            let main = slider.getElementsByClassName('swiper-container')[0];
            let thumbnail = slider.getElementsByClassName('swiper-container')[1];
            let api = new Swiper(main, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                on: {
                    slideChangeTransitionEnd: () => {
                        thumbnail.getElementsByClassName('selected')[0].classList.remove('selected');
                        thumbnail.getElementsByClassName('swiper-slide')[api.snapIndex].classList.add('selected');
                    },
                },
            });
            new Swiper(thumbnail, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                watchSlidesVisibility: true,
            });
            $(thumbnail).on('mouseenter', '.swiper-slide', (e) => {
                api.slideTo(Array.from(thumbnail.getElementsByClassName('swiper-slide')).indexOf(e.currentTarget));
            });
        });
    });

  $('.product__main-slider').on('click', '.swiper-slide', openImg);

  $('#MODAL_FIXED_IMG').on('hidden.bs.modal',() => {
    $('.product__main-slider .fi').removeClass('active');
  });

  function openImg (e) {
    const $target = $(e.currentTarget)
    const originalSrc = $target.find('.image')?.data('originalSrc');
    if (!originalSrc) return

    const $modal = $('#MODAL_FIXED_IMG');
    $modal.find('.img').attr('src', originalSrc);
    $target.find('.fi').addClass('active');

    $modal.modal('show');
  }
})($);
